import {Injectable} from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';
import {LoginUser} from '../neo-rest/neo-rest.sercive.model';
import {NeoStorageService} from 'ng-neo';
import {Observable} from "rxjs/Rx";
import {map} from "rxjs/operators";

interface User {
    username: string,
    name: string,
    userType: string,
    email: string,
    password: string
}

@Injectable()
export class NeoUserService {

    constructor(
        private _rest: NeoRestService,
        private _neoStorage: NeoStorageService
    ) {
    }

    /**
     * Loggea un usuario contra la API
     *
     * @param user Objeto con los parametros del usuario que quiere autenticarse
     * @return Un objeto observable
     * */
    loginUser(user: LoginUser) {
        return this._rest.postRaw('/auth/login', user)
            .pipe(
                map(({User, Token}) => {
                    // Comprobamos que no hayan errores
                    if (!User) {
                        return null;
                    }

                    // Guardamos el cliente
                    this._neoStorage.setNeoUser(User);
                    this._neoStorage.setToLocalStorage("token", Token);
                    return User;
                })
            );
    }

    /**
     * Desautentica un usuario contra la API
     *
     * @return Un objeto observable
     * */
    logoutUser() {
        return this._rest.get('/auth/logout/', null)
            .pipe(
                map(() => {
                    // Guardamos el cliente
                    return this._neoStorage.removeNeoUser();
                })
            );
    }

    /**
     * Obtiene la lista de usuarios
     */
    getUserList(): Observable<any> {
        return this._rest.get('/user');
    }

    /**
     * Lista de hoteles a los que el usuario tiene acceso
     *
     * @return Un objeto observable
     * */
    getHotelList() {
        return this._rest.post('/user/hotels/');
    }

    /**
     * Obtiene un usuario
     *
     * @param userId
     * @returns {Observable<any>}
     */
    getUser(userId) {
        return this._rest.postRaw('/user/byId/', {userId});
    }

    /**
     * Obtiene los datos del usuario logeado
     *
     * @returns {Observable<any>}
     */
    getMe() {
        return this._rest.get('/user/currentUser/');
    }


    /**
     * Crea un usuario
     *
     * @returns {Observable<any>}
     * @param user
     */
    createUser(user: User) {
        return this._rest.postRaw('/user', user);
    }

    /**
     * Actualiza los datos de un usuario
     * @param id
     * @param values
     * @returns {Observable<any>}
     */
    updateUser(id, values) {
        return this._rest.putRaw(`/user/${id}`, values);
    }

    /**
     * Actualiza los datos de un usuario
     * @param id Id del usuario
     * @returns {Observable<any>}
     */
    deleteUser(id: string) {
        return this._rest.delete(`/user/${id}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-user/neo-user.service.ts